import { render, staticRenderFns } from "./monthCard-relation.vue?vue&type=template&id=23589a90&scoped=true&"
import script from "./monthCard-relation.vue?vue&type=script&lang=js&"
export * from "./monthCard-relation.vue?vue&type=script&lang=js&"
import style0 from "./monthCard-relation.vue?vue&type=style&index=0&id=23589a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23589a90",
  null
  
)

export default component.exports